export const toSelectOptions = (items) => {
    return items.map((item) => ({
        value: item.deviceId,
        label: item.label || 'unknown',
    }));
}
